import { useTranslations } from "@jugl-web/utils";
import { FC } from "react";
import { RoundedButton, RoundedButtonProps } from "../RoundedButton";
import { ReactComponent as StopMdIcon } from "./assets/stop-md.svg";
import { ReactComponent as StopSmIcon } from "./assets/stop-sm.svg";

export const StopTimerButton: FC<Partial<RoundedButtonProps>> = ({
  size = "md",
  ...props
}) => {
  const { t } = useTranslations();

  return (
    <RoundedButton
      size={size}
      color="#EA5353"
      icon={size === "sm" ? <StopSmIcon /> : <StopMdIcon />}
      hint={t({
        id: "tasks-page.stop-timer",
        defaultMessage: "Stop timer",
      })}
      {...props}
    />
  );
};
